import { ArrowUpRight } from "lucide-react";
import { FadeUp } from "./Reveal";

const ITEMS = [
  { key: "clothing", img: "/assets/shop-clothing.png", name: "CLOTHING", blurb: "Aura tees & crews" },
  { key: "bags", img: "/assets/shop-bags.png", name: "BAGS", blurb: "Carry the compass" },
  { key: "jewelry", img: "/assets/shop-jewelry.png", name: "JEWELRY", blurb: "Suns, stars & moons" },
  { key: "customs", img: "/assets/shop-customs.png", name: "CUSTOMS", blurb: "One-of-one pieces" },
];

export default function Shop() {
  return (
    <section id="shop" data-testid="shop-section" className="aura-page relative bg-cream px-6 py-28 md:px-12 md:py-36">
      <div className="mx-auto max-w-7xl">
        <FadeUp>
          <p className="font-mono text-[10px] tracking-[0.45em] text-ink/50">01 — SHOP</p>
        </FadeUp>
        <FadeUp delay={0.08}>
          <h2 className="mt-4 flex flex-wrap items-baseline gap-x-4 text-ink">
            <span className="font-script text-6xl leading-none text-blush md:text-7xl">shop the</span>
            <span className="font-mono text-2xl tracking-[0.3em] md:text-4xl">UNIVERSE</span>
          </h2>
        </FadeUp>

        <div className="mt-14 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {ITEMS.map((item, i) => (
            <FadeUp key={item.key} delay={i * 0.1}>
              <a href="#shop" data-testid={`shop-card-${item.key}`} className="group block">
                <div className="overflow-hidden border border-ink/10 bg-white/40 p-2">
                  <div className="overflow-hidden">
                    <img
                      src={item.img}
                      alt={`MarStar Originals ${item.name.toLowerCase()}`}
                      loading="lazy"
                      className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                    />
                  </div>
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <div>
                    <p className="font-mono text-xs tracking-[0.35em] text-ink">{item.name}</p>
                    <p className="mt-1 text-sm text-ink/50">{item.blurb}</p>
                  </div>
                  <ArrowUpRight
                    size={18}
                    className="text-ink/40 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-blush"
                  />
                </div>
              </a>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
